// extracted by mini-css-extract-plugin
export default {"ManagerSidePanel":"styles_ManagerSidePanel__N6hLg","row":"styles_row__faQ+W","col":"styles_col__ALgPi"};